<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div class="col-md-12">
      <div class="page-breadcrumb"><!-- new -->
        <ul class="page-breadcrumb__trail">
          <li><a>Manage</a></li>
          <li><a>Aquaculture</a></li>
          <li><a>Observation Types</a></li>
        </ul>
        <div class="page-breadcrumb__icons">
          <a routerLink="/home"><img src="assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>
        </div>
      </div>
      <div class="block">
        <div class="page-header"> <!--changed new-->
          <span class="page-header__title">Observation Types</span>
          <img src="assets/images/New_Icons/refresh-icon.svg" alt="Refresh" title="Refresh" class="page-header__icon"
            width="17" height="17" (click)="!enableDisablePageLoader ? ngOnInit() : null" />
        </div>
        <div class="list_block">
          <div class="toolbar"> <!--search and new changed new-->
            <div class="toolbar__search">
              <img src="../../../../../../assets/images/New_Icons/search-icon.svg">
              <input type="text" (ngModelChange)="onSearchChanged()" [(ngModel)]="search" name="search"
                autocomplete="off" placeholder="Search by observation type name" />
            </div>
            <div class="toolbar__spacer"></div>
            <div class="toolbar__add-button" (click)="openForm()">
              <button type="button">
                <span class="toolbar__add-icon">
                  <img src="../../../../../../assets/images/New_Icons/plus-icon.svg" alt="Add Icon" />
                </span>
                <span class="toolbar__add-text">Add New</span>
              </button>
            </div>
          </div>
        </div>
        <div *ngIf="enableDisablePageLoader">
          <div class="adjust">
            <div class="loader2"></div>
          </div>
        </div>
        <!--transaction type cards-->
        <div class="cards_container" *ngIf="!enableDisablePageLoader">
          <div class="card_wrapper" *ngFor="let item of observationTypesList; let i = index">
            <div class="master-card">
              <div class="master-card-header">
                <div class="master-card-title">
                  <img src="../../../../../../assets/images/New_Icons/card-heading.svg">
                  <span>{{ item?.name }}</span>
                </div>
              </div>
              <div class="master-card-body">
                <div class="master-card-body-info">
                  <img src="../../../../../../assets/images/New_Icons/calendar-icon.svg">
                  <span>Created At: {{ item?.createdAt | date: "dd MMM yyyy"}}</span>
                </div>
                <div class="master-card-body-info">
                  <img src="../../../../../../assets/images/New_Icons/calendar-icon.svg">
                  <span>Updated At: {{ item?.updatedAt | date: "dd MMM yyyy"}}</span>
                </div>
                <div class="master-card-body-info">
                  <img src="../../../../../../assets/images/New_Icons/descriptio-card-icon.svg">
                  <span class="description">{{ item?.description ?? 'NA'}}</span>
                </div>
              </div>
              <div class="master-card-footer">
                <div class="master-card-footer-info">
                </div>
                <div class="action-icons">
                  <a>
                    <img src="../../../../../../assets/images/New_Icons/edit.svg" title="Edit Observation Type"
                      (click)="getOneById(item.id)">
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--transaction type cards end-->
        <div *ngIf="listLoader" class="loader-div">
          <div class="adjust">

            <div class="loader2 list-loader"></div>
          </div>
        </div>
        <div *ngIf="noList && !enableDisablePageLoader" class="noDataFoundMessage">Observation Types Not Found</div>
        <!--transactiontype block end-->
      </div>
      <!--add/update form-->
      <div class="dynamic-form-wrapper"
        [ngClass]="{ 'floating-panel': formFieldCount <= 7, 'slide-in-overlay': formFieldCount > 7}" *ngIf="showForm">
        <!--<div *ngIf="formFieldCount > 7" class="overlay-background" (click)="closeForm()"></div>-->
        <!--outside close-->
        <div class="popup-wrapper">
          <button type="button" class="popup-close-beside" (click)="clear()" title="Close">&times;</button>
          <!-- Actual Popup -->
          <div [ngClass]="{ 'form-container-panel': formFieldCount > 7, 'popup-inner': formFieldCount <= 7}">
            <form [formGroup]="registerForm" novalidate>
              <div class="form-header">
                <div class="form-title">Observation type</div>
                <button class="add-update-submit-button" (click)="addUpdateObservationType()"
                  [disabled]="submitButtonDisabled">
                  <span class="icon"><img src="../../../../../../assets/images/New_Icons/tick-icon.svg"></span>
                  <span class="text">{{ submitButton ? 'Submit' : 'Update' }}</span>
                </button>
              </div>
              <div class="form-container">

                <!-- Tank Usage Name -->
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Name</mat-label>
                  <input matInput type="text" id="name" formControlName="name" autocomplete="off"
                    placeholder="Enter name" />
                  <mat-hint><i>3–20 alphabetic characters</i></mat-hint>
                  <mat-error *ngIf="(f.name.touched || f.name.dirty || submitted) && f.name.errors">
                    <i>
                      {{
                      f.name.hasError('required') ? 'Name is required.' :
                      f.name.hasError('minlength') ? 'Minimum 3 characters required.' :
                      f.name.hasError('maxlength') ? 'Maximum 20 characters allowed.' :
                      f.name.hasError('pattern') ? 'Only alphabets allowed.' : ''
                      }}
                    </i>
                  </mat-error>
                </mat-form-field>

                <!-- Description -->
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Description</mat-label>
                  <textarea matInput id="description" formControlName="description" rows="3" autocomplete="off"
                    placeholder="Enter description"></textarea>
                  <mat-hint *ngIf="!f.description.errors"><i>Up to 200 characters</i></mat-hint>
                  <mat-error
                    *ngIf="(f.description.touched || f.description.dirty || submitted) && f.description.errors">
                    <i>
                      {{
                      f.description.hasError('required') ? 'Description is required.' :
                      f.description.hasError('maxlength') ? 'Maximum 200 characters allowed.' : ''
                      }}
                    </i>
                  </mat-error>
                </mat-form-field>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!--add/update form end-->
    </div>
  </div>
</div>